import { AnalyticsEvent } from "../models";

export class AlternatePickupConfirmationEvent implements AnalyticsEvent {
  name = 'AlternatePickupConfirmationEvent';
}